/* display-view-drop-down.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["triggerRef"];
import "./display-view-drop-down.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import { Box } from '@atlaskit/primitives/compiled';
import { displayViewDropDownMessages } from './messages';
var styles = {
  dropDownItemGroupStyles: "_2rko12b0 _1bsb1pna _4t3i7iqz"
};
var InlineIcon = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 10.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2.5v-3H6Zm4 0v3h8a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-8ZM4 11a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2Z",
  clipRule: "evenodd"
}));
var ListIcon = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5 7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7Zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5H7Zm2.5 3H8V8h1.5v1.5Zm6.5 0h-5V8h5v1.5Zm-6.5 3.25H8v-1.5h1.5v1.5Zm6.5 0h-5v-1.5h5v1.5ZM9.5 16H8v-1.5h1.5V16Zm6.5 0h-5v-1.5h5V16Z",
  clipRule: "evenodd"
}));
export var DisplayViewDropDown = function DisplayViewDropDown(_ref) {
  var onViewModeChange = _ref.onViewModeChange,
    viewMode = _ref.viewMode;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var isTable = viewMode === 'table';
  var triggerText = isTable ? formatMessage(displayViewDropDownMessages.viewModeListLabel) : formatMessage(displayViewDropDownMessages.viewModeInlineLinkLabel);
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    trigger: function trigger(_ref2) {
      var triggerRef = _ref2.triggerRef,
        triggerProps = _objectWithoutProperties(_ref2, _excluded);
      return /*#__PURE__*/React.createElement(Button, _extends({}, triggerProps, {
        ref: triggerRef,
        iconAfter: function iconAfter() {
          return /*#__PURE__*/React.createElement(ChevronDownIcon, {
            label: "",
            color: "currentColor",
            size: "small"
          });
        }
      }), triggerText);
    },
    testId: "datasource-modal--view-drop-down"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.dropDownItemGroupStyles
  }, /*#__PURE__*/React.createElement(DropdownItemGroup, null, /*#__PURE__*/React.createElement(DropdownItem, {
    testId: "dropdown-item-table",
    onClick: function onClick() {
      return onViewModeChange('table');
    },
    isSelected: isTable,
    description: formatMessage(displayViewDropDownMessages.viewModeListDescription),
    elemBefore: ListIcon
  }, /*#__PURE__*/React.createElement(FormattedMessage, displayViewDropDownMessages.viewModeListLabel)), /*#__PURE__*/React.createElement(DropdownItem, {
    testId: "dropdown-item-inline-link",
    onClick: function onClick() {
      return onViewModeChange('inline');
    },
    isSelected: !isTable,
    description: formatMessage(displayViewDropDownMessages.viewModeInlineLinkDescription),
    elemBefore: InlineIcon
  }, /*#__PURE__*/React.createElement(FormattedMessage, displayViewDropDownMessages.viewModeInlineLinkLabel)))));
};